import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { JwtHelperService } from '@auth0/angular-jwt'
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {

  fullname: string;
  dept_name: string;
  sup_name: string;
  level: string;

  jwtHelper = new JwtHelperService();

  constructor(private router: Router) { }

  ngOnInit() {
    const token = sessionStorage.getItem('token');

    if(token){
      const decoded: any = this.jwtHelper.decodeToken(token);

      this.fullname = decoded.fullname;
      this.dept_name = decoded.dept_name;
      this.sup_name = decoded.sup_name;
      this.level = sessionStorage.getItem('level');
      
    }else{
      this.router.navigate(['/login']);
    }
    
  }

  logout(){
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('fullname');
    sessionStorage.removeItem('cid');
    sessionStorage.removeItem('userid');
    sessionStorage.removeItem('level');
    sessionStorage.removeItem('sup');
    location.reload(true);
    // this.router.navigate(['/login']);

  }
}
